/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Typography,
  Box,
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemButton,
  Badge,
  Tooltip,
} from "@mui/material";
import { FixedSizeList, ListChildComponentProps } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { UseDashboardContext } from "src/context/dashboard";
import messengerIcon from "src/assets/images/chat/newmessengerlogo.webp";
import instagramIcon from "src/assets/images/chat/instagram_logo.png";
import whatsappIcon from "src/assets/images/chat/whatsapp.png";
import CustomAvatar from "src/components/shared/atoms/avatar/customAvatar";
import clsx from "clsx";
import { useFeature } from "src/context/global";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import useStyles from "./Styles";
import { Props } from "./Types";
import NoRecordFound from "../NoRecordFound";

const NameWithEllipsisTooltip: React.FC<{
  text: string;
  className: string;
}> = ({ text, className }) => {
  const [isOverflowed, setIsOverflowed] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsOverflowed(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  const nameTypography = (
    <Typography ref={textRef} className={className}>
      {text}
    </Typography>
  );

  return isOverflowed ? (
    <Tooltip title={text}>{nameTypography}</Tooltip>
  ) : (
    nameTypography
  );
};

const TotalPages: React.FC<Props> = ({
  title,
  dataList,
  source,
  chatTitle,
}) => {
  const { classes } = useStyles();
  const contextData = UseDashboardContext();

  const { canUse } = useFeature();
  const canViewSubordibatesChats = canUse("oversee_subordinates_stats");

  let storedAgentId: number = 0;
  let setStoredAgentId: (a: any) => void;
  if (contextData) {
    ({ storedAgentId, setStoredAgentId } = contextData);
  }

  const [isHover, setHover] = useState<number | null>(null);

  const agentDashboardOnclick = (index: number) => {
    setStoredAgentId(dataList[index].agentId);
  };

  const reusableListItem = useCallback(
    (itemPicture: string, name: string, index: number) => (
      <ListItemButton
        disableRipple
        disableTouchRipple
        className={classes.listButtonStylePending}
      >
        <ListItemAvatar>
          <CustomAvatar src={itemPicture} alt={name} />
        </ListItemAvatar>
        <ListItemText
          id={index.toString()}
          primary={
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography className={classes.primary}>{name}</Typography>
              {title === "Users" && canViewSubordibatesChats && (
                <Typography
                  onClick={() => {
                    agentDashboardOnclick(index);
                  }}
                  className={clsx(classes.buttonStyle, {
                    [classes.viewingStats]:
                      storedAgentId === dataList[index].agentId,
                    [classes.buttonStyleHover]:
                      isHover !== null && isHover === index,
                  })}
                >
                  view status
                </Typography>
              )}
              {title === "Pending Chats" && (
                <Typography
                  className={classes.listItemText}
                >{`${dataList[index].count} ${chatTitle} chats`}</Typography>
              )}
            </Box>
          }
        />
      </ListItemButton>
    ),
    [
      storedAgentId,
      title,
      classes,
      source,
      isHover,
      chatTitle,
      agentDashboardOnclick,
    ],
  );

  function renderRow(props: ListChildComponentProps) {
    const { index, style } = props;
    const name = dataList[index].name || dataList[index].pageName;
    const itemSource = dataList[index].source;
    const itemPicture = dataList[index].picture;

    const isPendingchatComp = title === "Pending Chats";
    const isBreakdownComp = title?.toLowerCase().includes("breakdown");

    if (isPendingchatComp || isBreakdownComp)
      return (
        <ListItem style={style} key={index} component="div">
          <ListItemButton
            disableRipple
            disableTouchRipple
            className={classes.listButtonStyle}
          >
            <ListItemAvatar>
              <Badge
                overlap="circular"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                badgeContent={
                  itemSource === "whatsapp" || source === "whatsapp" ? (
                    <img
                      style={{ width: "14px" }}
                      src={whatsappIcon}
                      alt="whatsapp"
                    />
                  ) : itemSource === "instagram" || source === "instagram" ? (
                    <img
                      style={{ width: "14px", borderRadius: "3px" }}
                      src={instagramIcon}
                      alt="instagram"
                    />
                  ) : itemSource === "chatbot" || source === "chatbot" ? (
                    <SmartToyIcon style={{ fontSize: "14px", color: "white", backgroundColor: "#4D1277", borderRadius: "50%", padding: "1px" }} />
                  ) : (
                    <img
                      style={{ width: "14px" }}
                      src={messengerIcon}
                      alt="messenger"
                    />
                  )
                }
              >
                <CustomAvatar src={itemPicture || ""} alt={name} />
              </Badge>
            </ListItemAvatar>
            <ListItemText
              id={index.toString()}
              primary={
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {isPendingchatComp && (
                    <Typography className={classes.primary}>{name}</Typography>
                  )}
                  {isBreakdownComp && (
                    <NameWithEllipsisTooltip
                      text={name}
                      className={classes.primary}
                    />
                  )}
                  {isPendingchatComp && (
                    <Typography className={classes.listItemText}>{`${dataList[index].count} ${chatTitle} ${
                      dataList[index].source === "facebook_comments"
                        ? dataList[index].count === 1
                          ? "comment"
                          : "comments"
                        : dataList[index].count === 1
                          ? "chat"
                          : "chats"
                    }`}</Typography>
                  )}
                  {isBreakdownComp && (
                    <Typography className={classes.listItemText}>{`${dataList[index].count} ${
                      dataList[index].count === 1 ? "chat" : "chats"
                    }`}</Typography>
                  )}
                </Box>
              }
            />
          </ListItemButton>
        </ListItem>
      );

    return (
      <ListItem
        style={style}
        onMouseEnter={() => setHover(index)}
        onMouseLeave={() => setHover(null)}
        className={title === "Active Users" ? classes.AgentListItem : undefined}
        key={index}
        component="div"
      >
        {/* for listContainerActive */}
        {storedAgentId === dataList[index].agentId ? (
          <Badge
            badgeContent="Viewing"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            className={classes.viewBadge}
          >
            {reusableListItem(itemPicture || "", name, index)}
          </Badge>
        ) : (
          reusableListItem(itemPicture || "", name, index)
        )}
      </ListItem>
    );
  }

  return (
    <Box className={classes.pageContainer}>
      {dataList.length > 0 ? (
        <AutoSizer>
          {({ height, width }: { height: number; width: number }) => (
            <FixedSizeList
              height={height}
              width={width}
              itemSize={65}
              itemCount={dataList.length}
              overscanCount={5}
            >
              {renderRow}
            </FixedSizeList>
          )}
        </AutoSizer>
      ) : (
        <NoRecordFound />
      )}
    </Box>
  );
};

export default TotalPages;

